import * as React from "react";
import { SVGProps } from "react";

const SvgFiveHearts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 248 347"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M237.7.8H10S.4 1.1.4 13.7v319.7c0 12.6 9.6 12.9 9.6 12.9h227.7s9.5-.3 9.5-12.9V13.7c0-12.6-9.5-12.9-9.5-12.9Z"
      fill="#fff"
    />
    <mask
      id="five-hearts_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={187}
      width={248}
      height={160}
    >
      <path
        d="M146 187.2H.5v146.1c0 12.6 9.6 12.9 9.6 12.9h227.6s9.5-.3 9.5-12.9V187.2H146Z"
        fill="url(#five-hearts_svg__a)"
      />
    </mask>
    <g mask="url(#five-hearts_svg__b)">
      <path
        d="M146 187.2H.5v146.1c0 12.6 9.6 12.9 9.6 12.9h227.6s9.5-.3 9.5-12.9V187.2H146Z"
        fill="url(#five-hearts_svg__c)"
      />
    </g>
    <mask
      id="five-hearts_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={248}
      height={174}
    >
      <path
        d="M.5 173.1H247.2V13.7c0-12.6-9.5-12.9-9.5-12.9H10.1S.5 1.1.5 13.7v159.4Z"
        fill="url(#five-hearts_svg__d)"
      />
    </mask>
    <g mask="url(#five-hearts_svg__e)">
      <path
        d="M.5 173.1H247.2V13.7c0-12.6-9.5-12.9-9.5-12.9H10.1S.5 1.1.5 13.7v159.4Z"
        fill="url(#five-hearts_svg__f)"
      />
    </g>
    <mask
      id="five-hearts_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={4}
      y={0}
      width={244}
      height={347}
    >
      <path
        d="M246.7 13.7v319.1c0 12.6-9.6 12.9-9.6 12.9H9.2s-2.1-.1-4.3-1.4c2.5 1.8 5 1.9 5 1.9h227.7s9.6-.3 9.6-12.9V13.7c0-12.6-9.6-12.9-9.6-12.9h-.5s9.6.3 9.6 12.9Z"
        fill="url(#five-hearts_svg__g)"
      />
    </mask>
    <g mask="url(#five-hearts_svg__h)">
      <path
        d="M246.7 13.7v319.1c0 12.6-9.6 12.9-9.6 12.9H9.2s-2.1-.1-4.3-1.4c2.5 1.8 5 1.9 5 1.9h227.7s9.6-.3 9.6-12.9V13.7c0-12.6-9.6-12.9-9.6-12.9h-.5s9.6.3 9.6 12.9Z"
        fill="url(#five-hearts_svg__i)"
      />
    </g>
    <mask
      id="five-hearts_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={243}
      height={347}
    >
      <path
        d="M1 333.4V14.2C1 1.6 10.6 1.3 10.6 1.3H238.5s2.1.1 4.3 1.4c-2.5-1.8-5-1.9-5-1.9H10.1S.5 1.1.5 13.7v319.7c0 12.6 9.6 12.9 9.6 12.9h.5c-.1-.1-9.6-.3-9.6-12.9Z"
        fill="url(#five-hearts_svg__j)"
      />
    </mask>
    <g mask="url(#five-hearts_svg__k)">
      <path
        d="M1 333.4V14.2C1 1.6 10.6 1.3 10.6 1.3H238.5s2.1.1 4.3 1.4c-2.5-1.8-5-1.9-5-1.9H10.1S.5 1.1.5 13.7v319.7c0 12.6 9.6 12.9 9.6 12.9h.5c-.1-.1-9.6-.3-9.6-12.9Z"
        fill="url(#five-hearts_svg__l)"
      />
      <mask
        id="five-hearts_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={25}
        width={1}
        height={299}
      >
        <path
          d="M.5 25.8v297.9c.2-.6.3-1.2.5-1.8V31.2c-.2-1.8-.4-3.6-.5-5.4Z"
          fill="url(#five-hearts_svg__m)"
        />
      </mask>
      <g mask="url(#five-hearts_svg__n)">
        <path
          d="M.5 25.8v297.9c.2-.6.3-1.2.5-1.8V31.2c-.2-1.8-.4-3.6-.5-5.4Z"
          fill="url(#five-hearts_svg__o)"
        />
      </g>
    </g>
    <path
      d="M26.7 67.5c-5.1 3.8-7.7 7.7-7.8 7.8-.1-.1-2.6-4.1-7.8-7.8-5.2-3.8-6.4-8.6-4.5-12.2 1.9-3.6 9.3-5.4 12.3 1.8 3-7.2 10.4-5.4 12.3-1.8 1.9 3.6.7 8.4-4.5 12.2ZM9.8 45.6V41h2.6c.4 1.5 1.1 2.6 2 3.3.9.7 2 1 3.4 1 1.9 0 3.4-.6 4.4-1.7 1-1.2 1.5-2.9 1.5-5.2 0-1.5-.3-2.8-.8-3.8s-1.2-1.7-2.1-2.2c-.9-.5-1.9-.7-3.1-.7-1 0-1.8.1-2.6.2-.7.1-1.5.3-2.3.6l-1.7-1V17h12c.5 0 .9 0 1.1-.1.2-.1.4-.2.5-.4.1-.2.3-.5.5-.9h1.7l-.3 5.1H14.1v9.6c.8-.3 1.6-.6 2.5-.7.9-.2 1.8-.2 2.7-.2 1.7 0 3.3.4 4.6 1.1 1.3.7 2.4 1.7 3.1 3 .7 1.3 1.1 2.8 1.1 4.5 0 1.9-.4 3.6-1.2 5-.8 1.4-2 2.5-3.5 3.2-1.5.7-3.4 1.1-5.5 1.1-2.7-.1-5.3-.6-8.1-1.7ZM219.6 279c5.1-3.8 7.7-7.7 7.8-7.8.1.1 2.6 4.1 7.8 7.8 5.2 3.8 6.4 8.6 4.5 12.2-1.9 3.6-9.3 5.4-12.3-1.8-3 7.2-10.4 5.4-12.3 1.8-2-3.6-.8-8.4 4.5-12.2ZM236.4 300.8v4.6h-2.6c-.4-1.5-1.1-2.6-2-3.3-.9-.7-2-1-3.4-1-1.9 0-3.4.6-4.4 1.7-1 1.2-1.5 2.9-1.5 5.2 0 1.5.3 2.8.8 3.8s1.2 1.7 2.1 2.2c.9.5 1.9.7 3.1.7 1 0 1.8-.1 2.6-.2.7-.1 1.5-.3 2.3-.6l1.7 1v14.4h-12c-.5 0-.9 0-1.1.1-.2.1-.4.2-.5.4-.1.2-.3.5-.5.9h-1.7l.3-5.1h12.5V316c-.8.3-1.6.6-2.5.7-.9.2-1.8.2-2.7.2-1.7 0-3.3-.4-4.6-1.1-1.3-.7-2.4-1.7-3.1-3-.7-1.3-1.1-2.8-1.1-4.5 0-1.9.4-3.6 1.2-5 .8-1.4 2-2.5 3.5-3.2 1.5-.7 3.4-1.1 5.5-1.1 2.7.3 5.3.8 8.1 1.8ZM93.7 82.5C83.5 90 78.4 97.8 78.3 98c-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.2 1.3 16.6-9 24.2ZM62.9 264.1c10.2-7.5 15.3-15.3 15.4-15.5.1.2 5.2 8 15.4 15.5 10.4 7.6 12.7 17.1 9 24.2-3.7 7.2-18.5 10.6-24.4-3.6-5.9 14.2-20.7 10.7-24.4 3.6-3.8-7.1-1.4-16.6 9-24.2ZM139.2 180.8c-10.2 7.5-15.3 15.3-15.4 15.5-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.8 7.1 1.4 16.6-9 24.2ZM184.8 82.5C174.6 90 169.5 97.8 169.4 98c-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.2 1.4 16.6-9 24.2ZM154 264.1c10.2-7.5 15.3-15.3 15.4-15.5.1.2 5.2 8 15.4 15.5 10.4 7.6 12.7 17.1 9 24.2-3.7 7.2-18.5 10.6-24.4-3.6-5.9 14.2-20.7 10.7-24.4 3.6-3.7-7.1-1.3-16.6 9-24.2Z"
      fill="#FF2601"
    />
    <defs>
      <radialGradient
        id="five-hearts_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(499.515 0 0 499.516 120.019 -116.964)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-hearts_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(499.515 0 0 499.516 120.019 -116.964)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="five-hearts_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(124.962 319.576) scale(357.935)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-hearts_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(124.962 319.576) scale(357.935)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="five-hearts_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-10.09 .645) scale(397.434)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-hearts_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-10.09 .645) scale(397.434)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="five-hearts_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(67.863 101.334) scale(338.506)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-hearts_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(67.863 101.334) scale(338.506)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-hearts_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 128.963 .322) scale(397.537)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="five-hearts_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 128.963 .322) scale(397.537)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgFiveHearts;
